/**
 * CHG-141 EDGE-002: 초대 비활성 상태별 안내·CTA 단일 상수.
 * 분산된 STATUS_MESSAGES 매핑 대신 본 상수만 사용.
 */
export type InvitationStatus = 'PENDING' | 'EXPIRED' | 'ACCEPTED' | 'DECLINED' | 'CANCELLED';

export type InvitationCtaKind =
  | 'go-org' // 본인이 그 조직 멤버이면 조직으로 이동
  | 'go-home' // 홈으로
  | 'request-reinvite'; // 안내만 — 별도 액션은 본 CHG 범위 외

export interface InvitationStatusLabel {
  title: string;
  message: string;
  cta: InvitationCtaKind;
}

export const INVITATION_STATUS_LABELS: Record<Exclude<InvitationStatus, 'PENDING'>, InvitationStatusLabel> = {
  EXPIRED: {
    title: '초대가 만료되었습니다',
    message: '이 초대는 만료되었습니다. 새 초대가 필요하면 조직 관리자에게 재초대를 요청해주세요.',
    cta: 'request-reinvite',
  },
  ACCEPTED: {
    title: '이미 수락된 초대입니다',
    message: '이 초대는 이전에 수락되었습니다.',
    cta: 'go-org',
  },
  DECLINED: {
    title: '거절한 초대입니다',
    message: '이전에 거절한 초대입니다. 새 초대가 필요하면 관리자에게 요청해주세요.',
    cta: 'go-home',
  },
  CANCELLED: {
    title: '철회된 초대입니다',
    message: '관리자가 이 초대를 철회했습니다. 자세한 사항은 관리자에게 문의해주세요.',
    cta: 'go-home',
  },
};

/**
 * verify-email 자동 합류 응답의 reason → 사용자 안내 메시지.
 * CHG-141 REQ-IF-010.
 */
export const AUTO_ACCEPT_REASON_MESSAGES: Record<string, string> = {
  expired: '초대가 만료되어 조직에 합류되지 않았습니다. 관리자에게 재초대를 요청해주세요.',
  cancelled: '관리자가 초대를 철회했습니다.',
  already_member: '이미 이 조직의 멤버입니다.',
  limit_exceeded: '조직 멤버 한도를 초과했습니다. 관리자에게 문의해주세요.',
  email_mismatch: '초대 대상 이메일과 가입 계정이 일치하지 않습니다.',
  invitation_not_found: '초대 정보를 찾을 수 없습니다.',
};
